export default __webpack_public_path__ + "static/media/tag-purple.5beead29.svg";